// API ////////////////////
import { toPascalCase } from '../Utils/common.util';

export const CreditSummaryUrl = (): string => `/ClubLink/GetSummery`;

export const CreditListUrl = (): string => `/ClubLink/GetCustomerActivity`;
